import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import { lastValueFrom } from 'rxjs';
import { ApiService } from 'services/api.service';
import { BackofficeReadingRoomSubmissionCard, ReadingRoomSubmissionChangeListItem } from 'types/service.interface';
import { formatDatetime } from 'util/date.utility';
import { CardTableComponent, CardTableConfig } from '../../card-table/card-table.component';

@Component({
  selector: 'app-reading-room-submission-versions',
  standalone: true,
  imports: [CardTableComponent, TooltipComponent, TranslateModule],
  templateUrl: './reading-room-submission-versions.component.html',
  styleUrl: './reading-room-submission-versions.component.scss'
})
export class ReadingRoomSubmissionVersionsComponent implements OnInit {
  public readonly formatDate = formatDatetime;
  #api = inject(ApiService);
  @Input() application?: BackofficeReadingRoomSubmissionCard;
  @Input() readingRoomSubmissionId?: string;

  tableConfig: CardTableConfig<ReadingRoomSubmissionChangeListItem> = {
    data: signal([]),
    columns: [
      {
        title: 'Notikuma datums',
        getter: (r) => formatDatetime(r.createdOn, false)
      },
      {
        title: 'Notikuma tips',
        convert: (r) => `enums.readingRoomSubmissionChangeType.${r.type}`
      },
      { title: 'Darbības veicējs', propertyName: 'createdBy' },
      {
        title: 'Rezultāts',
        customLogic: 'ValueCompare'
      }
    ],
    headerTitle: 'Pakalpojuma vēsturiskā gaita',
    headerTitleTooltip: 'subbmissionChangesTable'
  };

  async ngOnInit() {
    if (typeof this.readingRoomSubmissionId !== 'undefined') {
      const response = await lastValueFrom(this.#api.getReadingRoomSubmissionChanges(this.readingRoomSubmissionId));

      const data: ReadingRoomSubmissionChangeListItem[] = [];
      let firstVersionDateTime: Date | undefined = undefined;

      // Step 1: Identify the datetime of the FirstSubmittedVersion
      for (const r of response) {
        if (r.type === 'FirstSubmittedVersion') {
          firstVersionDateTime = new Date(r.createdOn);
          break;
        }
      }

      for (const r of response) {
        const rowDateTime = new Date(r.createdOn);

        if (firstVersionDateTime && firstVersionDateTime >= rowDateTime && r.type !== 'FirstSubmittedVersion') continue;

        const copy = { ...r };

        if (r.type === 'BackofficeStatus') {
          copy.oldValues = copy.oldValues ? `enums.backofficeReadingRoomSubmissionStatus.${copy.oldValues}` : '-';
          copy.newValues = copy.newValues ? `enums.backofficeReadingRoomSubmissionStatus.${copy.newValues}` : '-';
        }

        data.push(copy);
      }

      this.tableConfig.data.set(data);
    }
  }
}
